import React from "react";
import { validate } from "shared/yup";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { RootState } from "redux/store";
import { saveIntegration } from "redux/slice/integrations";
import { Integration } from "model/integration";
import { ClientEventWebhookCard } from "./card";
import { ClientEventWebhookModal, validationSchema } from "./modal";

const mapStateToProps = (_state: RootState) => ({});
const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({ saveIntegration }, dispatch);

interface Props extends ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps> {
	integration: Integration;
}

interface State {
	modalOpen: boolean;
	name?: string;
	url?: string;
	secret?: string;
	includeAnonymous: boolean;
	showValidation: boolean;
}

class Component extends React.Component<Props, State> {

	public constructor(props: Props) {
		super(props);
		this.state = {
			modalOpen: false,
			name: props.integration.name,
			url: props.integration.data.url as string,
			secret: props.integration.data.clientEventWebhookSecret as string,
			includeAnonymous: props.integration.data.clientEventWebhookIncludeAnonymousYN === "1",
			showValidation: false,
		};
	}

	public handleSave = () => {
		const { integration, saveIntegration } = this.props;
		const { name, url, secret, includeAnonymous } = this.state;
		const errors = validate(validationSchema, { url, secret });
		this.setState({ showValidation: true });
		if (!errors) {
			saveIntegration({ integration: {
				...integration,
				name,
				data: {
					...integration.data,
					url,
					clientEventWebhookSecret: secret,
					// YN feature value: "1" enables anonymous delivery, anything else is off.
					clientEventWebhookIncludeAnonymousYN: includeAnonymous ? "1" : "0",
				},
			}});
		}
	};

	public render() {
		const { integration } = this.props;
		const { modalOpen, showValidation, name, url, secret, includeAnonymous } = this.state;

		return (
			<>
				<ClientEventWebhookCard
					integration={integration}
					onViewIntegration={() => this.setState({ modalOpen: true })}
				/>
				<ClientEventWebhookModal
					open={modalOpen}
					onClose={() => this.setState({ modalOpen: false })}
					integration={integration}
					name={name}
					url={url}
					secret={secret}
					includeAnonymous={includeAnonymous}
					showValidation={showValidation}
					onNameChange={name => this.setState({ name })}
					onUrlChange={url => this.setState({ url })}
					onSecretChange={secret => this.setState({ secret })}
					onIncludeAnonymousChange={includeAnonymous => this.setState({ includeAnonymous })}
					onSave={this.handleSave}
				/>
			</>
		);
	}

}

export const ClientEventWebhookIntegration = connect(mapStateToProps, mapDispatchToProps)(Component);
